module.exports = __webpack_public_path__ + "static/media/iconIsRadioButton.7b3ff0cd.svg";